/**
 * Global axios request interceptor that injects the active branch as the
 * `x-branch-id` header on every request. The backend uses this to scope admin
 * catalog reads/writes to a single branch.
 *
 *  - Branch-scoped admin: always their own primaryBranchId (the server enforces
 *    this independently, so a tampered header cannot widen their access).
 *  - Global admin (super admin / canAccessAllBranches): the topbar switcher
 *    selection (null = all branches → no header sent).
 *  - Not logged in / non-admin: no active branch → no header.
 *
 * Registered once at app startup (imported from src/index.js).
 */
import axios from "axios";
import { getActiveBranchId } from "../services/PermissionService";

axios.interceptors.request.use(
  (config) => {
    try {
      const branchId = getActiveBranchId();
      if (branchId) {
        config.headers = config.headers || {};
        config.headers["x-branch-id"] = branchId;
      }
    } catch (error) {
      /* never block a request because of branch resolution */
    }
    return config;
  },
  (error) => Promise.reject(error)
);
